/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import icono_whatsapp_footer from '../../Recursos/icono_whatsapp_footer.svg';
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {irMapa} from "../../Utilidades/irMapa";

const Tarjeta_Puntos = ({item}) => {
    const {sTab} = useResponsive()

    return (


        <Grid container size={{xs: 12, sm: 12, md: 12}}
              alignItems={'center'}

              sx={{
                  background: `linear-gradient(0deg, ${theme.palette.primary.main} 20%, transparent 80%), url(${item.imagen})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  borderRadius: 4,
                  color: '#fff',
                  p: 3
              }}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{marginTop: sTab ? 10 : 16}}>
                <Typography
                    sx={{fontSize: 32, fontWeight: 800,}}>
                    {item.nombre}
                </Typography>
            </Grid>


            <Grid container size={{xs: 6, sm: 6, md: 6}}>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}>


                    <Grid container size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 2, sm: 2, md: 2}} justifyContent={'center'}>
                            <LocationOnIcon/>
                        </Grid>

                        <Grid container size={{xs: 10, sm: 10, md: 10}}>
                            <Typography>
                                {item.direccion}
                            </Typography>
                        </Grid>

                    </Grid>

                    <Grid container
                          size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 2, sm: 2, md: 2}} justifyContent={'center'}>
                            <img alt={'icono whatsapp'} src={icono_whatsapp_footer} width={18}/>
                        </Grid>

                        <Grid container size={{xs: 10, sm: 10, md: 10}}>
                            <Typography>
                                {item.numero}
                            </Typography>
                        </Grid>


                    </Grid>

                </Grid>


            </Grid>


            <Grid container
                  justifyContent={'flex-end'}
                  alignItems={'flex-start'}
                  size={{xs: 6, sm: 6, md: 6}}>
                <Button
                    onClick={() => irMapa({lat: item.lat, long: item.long})}
                    startIcon={<LocationOnIcon/>}
                    sx={{
                        color: theme.palette.primary.main,
                        background: 'white',
                        borderRadius: 6,
                        paddingY: 0.5,
                        fontWeight: 600
                    }}>

                    LLÉVAME


                </Button>

            </Grid>


        </Grid>


    )

}
export default Tarjeta_Puntos